import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

let navigation_blocks = $('.nav-indicator-container')
let scroll_triggers = $('.scroll-trigger')

var tl1 = gsap.timeline({ repeat: -1, force3D: false })

navigation_blocks.each(function (k, v) {

  let navName = $(this).attr('data-nav-name')

  if(navName.length > 0) {

    tl1.add(navName)

    if (k === 0) {
      tl1.from('.' + navName, {})
    } else {
      tl1.from('.' + navName + ' .dot', { opacity: 0 })
      tl1.from('.' + navName, { opacity: 0.4 })
    }
    tl1.addPause()
    tl1.to('.' + navName + ' .dot', { opacity: 0 })
  }

})

scroll_triggers.each(function (e) {

  ScrollTrigger.create({
    trigger: this,
    start: 'top center',
    end: 'bottom center',
    onEnter: playNav,
    onEnterBack: playNav,
    //markers: true
  })

})

function playNav (e) {
  $('.navigation-indicators').removeClass('white')
  let nav = $(e.trigger).attr('data-nav-name')
  let colorClass = $(e.trigger).attr('data-nav-color')
  if (colorClass) {
    $('.navigation-indicators').addClass(colorClass)
  }
  if (nav) {
    tl1.play(nav)
  }
}

$('body').on('click', '.nav-scroll-to', function (e) {

  let indicatorName = $(this).attr('data-nav-name')

  if($('.scroll-trigger[data-nav-name=' + indicatorName + ']').length) {

    e.preventDefault()

    tl1.play(indicatorName)
    scrollTo(indicatorName)
    if ($('.hamburger').hasClass('is-active')) {
      changeMobileMenu()
    }
    history.pushState({}, null, '/')
  }

})

function scrollTo (indicatorName) {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: '.scroll-trigger[data-nav-name=' + indicatorName + ']',
      offsetY: 138,
    },
    ease: 'power',
    force3D: false,
  })
}

$(window).on('load', function (e){

  if(location.hash && location.hash.length > 1) {
    let indicatorName = location.hash.substring(1)
    if(indicatorName.length > 0 && $('.scroll-trigger[data-nav-name=' + indicatorName + ']').length) {
      tl1.play(indicatorName)
      scrollTo(indicatorName)
      if ($('.hamburger').hasClass('is-active')) {
        changeMobileMenu()
      }
    }
  }



})

